/* DTK cart resilience — retries cart requests on 429 / 5xx / non-JSON (bot-challenge)
   responses with exponential backoff + Retry-After, so add-to-cart and the cart drawer
   no longer fail silently when the storefront throttles a burst of requests.
   Scoped strictly to /cart* and ?section_id= requests; a no-op for everything else. */
(function () {
  if (window.__dtkCartResilience) return;
  window.__dtkCartResilience = true;

  var origFetch = window.fetch.bind(window);
  var wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };

  function classify(input) {
    var raw = (typeof input === 'string') ? input : (input && input.url) || '';
    var u;
    try { u = new URL(raw, window.location.origin); } catch (e) { return { cart: false, json: false }; }
    var isCart = /^\/cart(\/|\.|$)/.test(u.pathname) || u.search.indexOf('section_id=') !== -1;
    var json = /^\/cart(\.js)?$/.test(u.pathname) || /^\/cart\/(add|change|update|clear)(\.js)?$/.test(u.pathname);
    if (u.search.indexOf('section_id=') !== -1) json = false; // section renders return HTML, not JSON
    return { cart: isCart, json: json };
  }

  window.fetch = function (input, init) {
    var info = classify(input);
    if (!info.cart) return origFetch(input, init);

    var retries = 3, base = 700, attempt = 0;
    function attemptFetch() {
      return origFetch(input, init).then(function (res) {
        if (res.status === 429 || res.status >= 500) {
          if (attempt < retries) {
            var ra = parseFloat(res.headers.get('retry-after'));
            attempt++;
            return wait((isNaN(ra) ? base * Math.pow(2, attempt - 1) : ra * 1000) + Math.random() * 250).then(attemptFetch);
          }
          return res;
        }
        if (info.json) {
          return res.clone().text().then(function (t) {
            var ok = true; try { JSON.parse(t); } catch (e) { ok = false; }
            if (!ok && attempt < retries) {
              attempt++;
              return wait(base * Math.pow(2, attempt - 1) + Math.random() * 250).then(attemptFetch);
            }
            return res;
          }).catch(function () { return res; });
        }
        return res;
      }).catch(function (err) {
        if (attempt < retries) {
          attempt++;
          return wait(base * Math.pow(2, attempt - 1) + Math.random() * 250).then(attemptFetch);
        }
        throw err;
      });
    }
    return attemptFetch();
  };
})();
